import "react-responsive-carousel/lib/styles/carousel.min.css";

import {
  PRODUCT_LOGIN_TOUR_DETAILS,
  PRODUCT_SIGNUP_TOUR_DETAILS,
} from "utilFunctions/Constants/auth";
import ProductTourBanner from "./ProductTourBanner";
import "./login.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import styled from "styled-components";
import { LoginForm } from "Pages/LoginPage/LoginForm";
import { config } from "config.js";
interface productTourDetails {
  imgUrl: string;
  heading: string;
  description: string;
}
const MainDiv = styled<any>("div")`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "row" : "column"};
`;
const Div2 = styled<any>("div")`
  position: relative;
  width: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "50%" : "100%"};
  height: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "100vh" : "50vh"};
  display: flex;
  justify-content: center;
  flex-direction: column;
  heigth: 50vh;
`;
const DivsubHeadinLoginPage = styled<any>("div")`
  color: var(--White, #fff);
  text-align: center;
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "20px" : "12px"};
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
`;
const DivSubHeadinLoginPage2 = styled<any>("div")`
  color: #757575;
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "12px"};
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  display: flex;
  justify-content: center;
  margin-top: 20%;
`;
const DivSubHeadinLoginPage3 = styled<any>("div")`
  color: #757575;
  text-align: center;
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "14px" : "10px"};
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  white-space: pre-line;
  word-wrap: break-word;
  margin-top: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "24px" : "14px"};
`;
const LoginPage = () => {
  const { screen }: any = useWindowSize();
  const productTourDetails =
    PRODUCT_LOGIN_TOUR_DETAILS || PRODUCT_SIGNUP_TOUR_DETAILS;

  console.log("screen", screen);
  return (
    <MainDiv screen={screen}>
      <div
        className={
          ["xxl", "xl", "lg"].includes(screen) ? "loginPageDK" : "loginPage"
        }
      >
        <div className="p-3">
          <div>
            {productTourDetails.map(
              ({ imgUrl, heading, description }: productTourDetails) => {
                return (
                  <ProductTourBanner
                    key={imgUrl}
                    heading={heading}
                    description={description}
                    imgUrl={imgUrl}
                  />
                );
              }
            )}
          </div>
          <DivsubHeadinLoginPage screen={screen}>
            Your hub for empowering education and innovation!
          </DivsubHeadinLoginPage>
        </div>
      </div>

      <Div2 screen={screen}>
        <div
          className={`${
            ["xxl", "xl", "lg"].includes(screen)
              ? "aakashLogoWeb"
              : "aakashLogoMobile"
          }`}
        >
          <img
            src={config.aakashLogo}
            alt={"image"}
            width={"110px"}
            height={"80px"}
          />
        </div>
        <DivSubHeadinLoginPage2 screen={screen}>
          Experience seamless login using your AESL ID.
        </DivSubHeadinLoginPage2>
        <div className="d-flex justify-content-center align-items-center">
          <LoginForm />
        </div>
        <DivSubHeadinLoginPage3 screen={screen}>
          {`For any assistance with the login process, contact your
        branch's EDP team.`}
        </DivSubHeadinLoginPage3>
      </Div2>
    </MainDiv>
  );
};

export default LoginPage;
